<template>
  <div class="validation_request_address_container" >
    <div class="addresse">
      <h5>{{this.get_str_title()}}</h5>
      <ul>
        <li v-if="validation_requestable.corporation_name">Société : {{validation_requestable.corporation_name}}</li>
        <li v-if="address_name">Nom : {{address_name}}</li>
        <li>{{validation_requestable.street_line1}}</li>
        <li v-if="validation_requestable.street_line2">{{validation_requestable.street_line2}}</li>
        <li>{{validation_requestable.zipcode}} {{validation_requestable.city}}</li>
        <li>{{validation_requestable.state}} {{validation_requestable.decoded_country}}</li>
      </ul>
    </div>
    <div v-if="has_complement" class="informations-complement">
      <h5>Informations complémentaires</h5>
       <ul>
        <li v-if="validation_requestable.mail_forward_default"> Adresse de réexpédition par défaut</li>
        <li v-if="validation_requestable.mail_forward_start_date"> Date de début d'usage pour réexpédition : {{ validation_requestable.mail_forward_start_date | moment-date }}</li>
        <li v-if="validation_requestable.mail_forward_end_date"> Date de fin d'usage pour réexpédition : {{ validation_requestable.mail_forward_end_date | moment-date }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name:"Address",
  props:["validation_requestable"],
  computed: {
    address_name() {
      let first_name = this.validation_requestable.first_name == null ? '' : this.validation_requestable.first_name
      let last_name = this.validation_requestable.last_name == null ? '' : this.validation_requestable.last_name

      return (first_name + ' ' + last_name).trim()
    },
    has_complement() {
      return (this.validation_requestable.mail_forward_default != null ||
            this.validation_requestable.mail_forward_start_date != null ||
              this.validation_requestable.mail_forward_end_date != null)
    },
  },
  methods: {

    get_str_title()
    {
      var title = "Adresse"

      if ( "customer" === this.validation_requestable.type )
      {
        title += this.validation_requestable.customer_usage === "main" ? " " : " de "

        title += this.validation_requestable.decoded_customer_usage
      }
      else if ( "customer_representative" === this.validation_requestable.type )
        title += " de représentant légal"
      else if ( "mail_forward" === this.validation_requestable.type )
        title += " de réexpédition"

      return title
    },
  }
}
</script>

<style scoped>
.validation_request_address_container {
  padding: 0 15px;
  border: solid 1px lightgray;
  background-color: white;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}

.validation_request_address_container > div { margin-right: 15px; width: 100%; }
.validation_request_address_container > div:last-child { margin-right: 0; }

.addresse, .informations-complement {}
.addresse > h5, .informations-complement > h5 { border-bottom: 1px solid lightgray; padding-bottom: 5px; }

</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Address.vue